import React from "react";
import { AiOutlineShop } from "react-icons/ai";
import { PiBuildingsLight } from "react-icons/pi";
import { GiFireplace } from "react-icons/gi";
import { FaCheckCircle } from "react-icons/fa";
import house from "../../../utils/Icons/Housee.svg";
import store from "../../../utils/Icons/coffee-shops.svg";
import business from "../../../utils/Icons/BusinessBuilding.svg";
import CustomSVG from "../../../utils/Icons/CustomSVG";
export const Left = ({data}) => {
  const fillColor = localStorage.getItem('dark') === true ? '#6C6C6C' : '#C7C7C7'; // black for light theme, white for dark theme

  return (
    <div className="md:pt-[18px] lg:w-[740px]">
      <img
        className="rounded-xl w-full h-[280px] md:h-[442px] object-cover"
        src={data.card.picture}
        alt=""
      />
      <div className="pt-2 flex items-center space-x-2 w-full">
        <img
          className="w-full h-[46px] md:h-[82px] object-cover rounded-lg"
          src="https://images.pexels.com/photos/27168077/pexels-photo-27168077/free-photo-of-shadow.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt=""
        />
        <img
          className="w-full h-[46px] md:h-[82px] object-cover rounded-lg"
          src="https://images.pexels.com/photos/27168077/pexels-photo-27168077/free-photo-of-shadow.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt=""
        />
        <img
          className="w-full h-[46px] md:h-[82px] object-cover rounded-lg"
          src="https://images.pexels.com/photos/27168077/pexels-photo-27168077/free-photo-of-shadow.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt=""
        />
        <img
          className="w-full h-[46px] md:h-[82px] object-cover rounded-lg"
          src="https://images.pexels.com/photos/27168077/pexels-photo-27168077/free-photo-of-shadow.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt=""
        />
        <img
          className="w-full h-[46px] md:h-[82px] object-cover rounded-lg"
          src="https://images.pexels.com/photos/27168077/pexels-photo-27168077/free-photo-of-shadow.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt=""
        />
      </div>
      <div className="py-[28px]">
        <h1 className="text-2xl md:text-[28px] pb-4">Product Description</h1>
        <p>
          This beautifully crafted mobile UI kit is now compatible with Figma,
          Sketch, and Adobe XD so you have the total freedom to create
          outstanding designs with your preferred design tool. Now, what is
          fancy about this UI kit?
        </p>
        <p className="pt-2">
          In my opinion, the most exciting aspect of this Figma resource is its
          incredible creativity. It allows you to make your mobile app designs
          stand out from the rest of the competition. No detail is left out,
          ensuring that your app is unique and attractive to users. It helps
          you:
        </p>
      </div>
      <hr className=" dark:border-gray-500 border-[#D3D3D3]" />
      <div className="py-[28px]">
        <h1 className="text-2xl md:text-[28px] pb-4">
          What Problem Does It Solve?
        </h1>
        <p>
          If you lack inspiration and don’t know where to start when it comes to
          designing mobile apps, Atro will help you get unstuck with 150 mobile
          screens ready to be customized according to your needs.
        </p>
      </div>
      <hr className="my-4 dark:border-gray-500 border-[#D3D3D3]" />
      <div>
        <h1 className="text-2xl md:text-[28px] pb-4 ">Who’s it for?</h1>
        <div className="flex space-x-4">
        <CustomSVG fill={fillColor} />
          <p className="w-3/4">
            Business owners from the coffee industry that want to distribute
            their quality coffee with ease.
          </p>
        </div>
        <div className="flex space-x-4 py-5">
          <img src={business} alt="" />
          <p className="w-3/4">
            Design agencies that require design assets to develop client
            projects and don’t have time to produce design from scratch
          </p>
        </div>
        <div className="flex space-x-4">
          <img src={house} alt="" />
          <p className="w-3/4">
            Design studios and startups who can’t afford to hire a designer.
          </p>
        </div>
      </div>
      <hr className="my-4 dark:border-gray-500 border-[#D3D3D3]" />
      <div className="flex flex-col gap-3">
        <h1 className="text-2xl md:text-[28px] pb-1">Key Points</h1>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl shrink-0" />
          <p>50+ Screens beautifully crafted mobile design views</p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl shrink-0" />
          <p>
            Icons & Spot illustrations library organized and easily customizable
            in external libraries
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl shrink-0" />
          <p>
            Organized Components sheets with components, typography, colors, and
            effects
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl shrink-0" />
          <p>Free Font typography based on the Montserrat font family</p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl" />
          <p>Meticulously layered & vector</p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl" />
          <p>Icons & Spot illustrations library</p>
        </div>
        <div className="flex items-center space-x-4">
          <FaCheckCircle className="text-[#30A242] text-xl" />
          <p>Instructions included</p>
        </div>
      </div>
    </div>
  );
};
